<template>
  <div :class="['input-container', {focused: isLabelCollapsed}]">
    <input
      v-model="modelValue"
      v-bind="$attrs"
      :id="inputId"
      :class="[inputClass, {has_error: error}]"
      :name="inputName"
      :maxlength="maxLength"
      type="tel"
      inputmode="numeric"
      @focus="handleInputFocus"
      @blur="handleInputBlur"
    />

    <label :for="inputId" class="placeholder-label">{{ label }}</label>
  </div>

  <div v-if="isErrorMessageVisible" class="error_text">{{ errorMessage }}</div>
</template>

<script setup>
import useTextInputHook from '@/hooks/useTextInput.js';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  maxLength: {
    type: Number,
    default: null,
  },
  inputId: {
    type: String,
    default: 'inputPin',
  },
  inputClass: {
    type: String,
    default: 'code-input',
  },
  inputName: {
    type: String,
    default: 'mobile',
  },
  error: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
    default: '',
  },
});

const modelValue = defineModel({
  type: [String, Number],
});

const {
  isLabelCollapsed,
  isErrorMessageVisible,
  handleInputFocus,
  handleInputBlur,
} = useTextInputHook(modelValue, undefined, () => ({ error: props.error, errorMessage: props.errorMessage }));
</script>
